import React from 'react';
import { LeadShortcut } from './LeadShortcut';

export const LeadShortcutFactory = ({ widgetInformation }) => {
  const title = widgetInformation.config.title;
  return <LeadShortcut title={title} />;
};
